// Convert normal share URLs (SoundCloud, Bandcamp, Spotify, YouTube, Instagram, Facebook)
// — OR a full <iframe ... src="..."></iframe> HTML paste — into an embeddable iframe src URL.
export function toEmbedSrc(url) {
    if (!url) return "";
    let u = String(url).trim();

    // If the user pasted a full <iframe ... src="..."> snippet, extract the src.
    const iframeMatch = u.match(/<iframe[^>]*\ssrc\s*=\s*["']([^"']+)["']/i);
    if (iframeMatch) u = iframeMatch[1].trim();

    // Already an embed URL (from a direct paste) — return as-is so query params like ?si=... survive
    if (/youtube\.com\/embed\//i.test(u)) return u;
    if (/player\.vimeo\.com\/video\//i.test(u)) return u;
    if (/w\.soundcloud\.com\/player/i.test(u)) return u;
    if (/open\.spotify\.com\/embed\//i.test(u)) return u;
    if (/instagram\.com\/(p|reel|tv)\/[^/]+\/embed/i.test(u)) return u;
    if (/facebook\.com\/plugins\//i.test(u)) return u;
    if (/bandcamp\.com\/EmbeddedPlayer/i.test(u)) return u;

    // SoundCloud share URL
    if (/soundcloud\.com/i.test(u)) {
        return `https://w.soundcloud.com/player/?url=${encodeURIComponent(u)}&color=%23111111&auto_play=false&hide_related=true&show_comments=false&show_user=true&show_reposts=false&show_teaser=false`;
    }
    // Spotify open link → embed
    const sp = u.match(/open\.spotify\.com\/(track|album|artist|playlist|episode|show)\/([A-Za-z0-9]+)/i);
    if (sp) return `https://open.spotify.com/embed/${sp[1]}/${sp[2]}?utm_source=generator&theme=0`;
    // YouTube full/short URL → embed
    let yt = u.match(/youtu\.be\/([A-Za-z0-9_-]{6,})/i);
    if (yt) return `https://www.youtube.com/embed/${yt[1]}`;
    yt = u.match(/youtube\.com\/watch\?[^ ]*v=([A-Za-z0-9_-]{6,})/i);
    if (yt) return `https://www.youtube.com/embed/${yt[1]}`;
    // Instagram post/reel/tv → embed
    const ig = u.match(/instagram\.com\/(p|reel|tv)\/([A-Za-z0-9_-]+)/i);
    if (ig) return `https://www.instagram.com/${ig[1]}/${ig[2]}/embed`;
    // Facebook video (watch, /videos/, fb.watch short) → plugin
    if (/facebook\.com\/watch/i.test(u) || /facebook\.com\/[^/]+\/videos\//i.test(u) || /fb\.watch\//i.test(u)) {
        return `https://www.facebook.com/plugins/video.php?href=${encodeURIComponent(u)}&show_text=false&autoplay=false`;
    }
    // Facebook post/photo → plugin
    if (/facebook\.com\/[^/]+\/posts\//i.test(u) || /facebook\.com\/photo/i.test(u) || /facebook\.com\/[^/]+\/photos\//i.test(u)) {
        return `https://www.facebook.com/plugins/post.php?href=${encodeURIComponent(u)}&show_text=false`;
    }
    // Unknown — return as-is
    return u;
}

// Detect what kind of media is behind a URL (used for aspect-ratio & layout tuning)
export function embedKind(url) {
    if (!url) return "unknown";
    let u = String(url).toLowerCase();
    const m = u.match(/<iframe[^>]*\ssrc\s*=\s*["']([^"']+)["']/i);
    if (m) u = m[1];
    if (u.includes("soundcloud")) return "audio";
    if (u.includes("spotify")) return "audio";
    if (u.includes("bandcamp")) return "audio";
    if (u.includes("youtube") || u.includes("youtu.be")) return "video";
    if (u.includes("vimeo")) return "video";
    if (u.includes("instagram.com/reel") || u.includes("/tv/")) return "vertical-video";
    if (u.includes("instagram")) return "photo";
    if (u.includes("facebook") || u.includes("fb.watch")) return "video";
    return "unknown";
}

// Derive a thumbnail image URL from a share URL when possible.
// Currently supports YouTube. Returns "" for services without a public thumb URL.
export function thumbFromUrl(url) {
    if (!url) return "";
    let u = String(url).trim();
    const m = u.match(/<iframe[^>]*\ssrc\s*=\s*["']([^"']+)["']/i);
    if (m) u = m[1];
    // YouTube — pull the video id from every common shape.
    let yt = u.match(/youtu\.be\/([A-Za-z0-9_-]{6,})/i)
        || u.match(/youtube\.com\/(?:watch\?[^ ]*v=|embed\/|v\/)([A-Za-z0-9_-]{6,})/i);
    if (yt) return `https://img.youtube.com/vi/${yt[1]}/hqdefault.jpg`;
    return "";
}
